import run from '../../utilities/run';
import render from '../../utilities/render';
import PasswordGuidelinesLogic from './passwordGuidelinesLogic';

// NOTE: make the target selector a place on the webpage where you want to import this
const targetSelector = "#update-password-container";

run(targetSelector, (outerEl)=>{
 attachHtml(outerEl);
});

function attachHtml(outerEl){
  const passwordGuidelinesLogic = new PasswordGuidelinesLogic(outerEl);
  passwordGuidelinesLogic.init();
};



// WEBPACK FOOTER //
// ./src/pages/passwordGuidelines/passwordGuidelines.js